import { SET_CHECK_CALLS, CLEAR_CHECK_CALLS } from '../actionTypes'
// import moment from 'moment'
// import _ from 'lodash'

const initialState = []

export default (state=initialState,  payload) => {
    switch(payload.type) {

    case SET_CHECK_CALLS:
        return payload.checkcalls || null
    case CLEAR_CHECK_CALLS:
        return initialState
    default:
        return state
    }
}